import React, { useState, useEffect } from 'react';
import { getMyAwards } from '../../../api/AwardsAPI';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import { formatMonthYear } from '../../../commonfunctions';

const MyAwardsPage = () => {
    const [awards, setAwards] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getMyAwards((data) => {
            if (Array.isArray(data)) {
                setAwards(data);
            }
            setIsLoading(false);
        });
    }, []);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' });
    };

    if (isLoading) {
        return <div className="text-center p-5"><div className="spinner-border"></div></div>;
    }

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="My Trophy Cabinet" />
                <div className="row">
                    {!isLoading && awards.length > 0 ? (
                        awards.map(award => (
                            <div className="col-md-6 col-lg-4 project-card" key={award.id}>
                                <div className="card hover-effect h-100">
                                    <div className="card-header bg-primary text-white d-flex justify-content-center">
                                        <div className="d-flex align-items-center">
                                            <div className="h-40 w-40 d-flex-center b-r-50 overflow-hidden bg-light-primary text-primary me-2">
                                                <i className="fas fa-trophy fa-lg text-white"></i>
                                            </div>
                                            <h5 className="m-0 f-w-600 text-white">{award.award_type}</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text fs-5 text-center">"{award.description}"</p>
                                    </div>

                                    {/* --- START: UPDATED CARD FOOTER --- */}
                                  <div className="card-footer text-center">
                                        <span className="badge bg-danger fs-6">
                                            {formatMonthYear(award.start_date)} - {formatMonthYear(award.end_date)}
                                        </span>
                                    </div>
                                    {/* --- END: UPDATED CARD FOOTER --- */}

                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12">
                             <div className="card mb-3">
                                <div className="row g-0">
                                    <div className="col-md-8"><div className="card-body"><h5 className="card-title">No Awards Yet!</h5><p className="card-text">Your trophy cabinet is empty for now, but keep playing to earn your first award.</p></div></div>
                                    <div className="col-md-4"><img alt="No data illustration" className="img-fluid" src="/assets/images/blog-app/09.jpg" /></div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </main>
    );
};

export default MyAwardsPage;